export default [
  {
  "anonymous": false,
  "inputs": [
  {
  "indexed": true,
  "internalType": "address",
  "name": "owner",
  "type": "address"
  },
  {
  "indexed": true,
  "internalType": "address",
  "name": "token",
  "type": "address"
  },
  {
  "indexed": false,
  "internalType": "uint192",
  "name": "amount",
  "type": "uint192"
  },
  {
  "indexed": false,
  "internalType": "uint64",
  "name": "depositTimestamp",
  "type": "uint64"
  }
  ],
  "name": "Deposit",
  "type": "event"
  },
  {
  "anonymous": false,
  "inputs": [],
  "name": "EmergencyModeEnabled",
  "type": "event"
  },
  {
  "anonymous": false,
  "inputs": [
  {
  "indexed": true,
  "internalType": "address",
  "name": "who",
  "type": "address"
  },
  {
  "indexed": true,
  "internalType": "address",
  "name": "to",
  "type": "address"
  },
  {
  "indexed": true,
  "internalType": "address",
  "name": "token",
  "type": "address"
  },
  {
  "indexed": false,
  "internalType": "uint256",
  "name": "amount",
  "type": "uint256"
  }
  ],
  "name": "EscapeHatchWithdrawal",
  "type": "event"
  },
  {
  "anonymous": false,
  "inputs": [
  {
  "indexed": false,
  "internalType": "uint64",
  "name": "initialWithdrawalDelay",
  "type": "uint64"
  },
  {
  "indexed": false,
  "internalType": "address",
  "name": "initialHermezGovernanceAddress",
  "type": "address"
  },
  {
  "indexed": false,
  "internalType": "address",
  "name": "initialEmergencyCouncil",
  "type": "address"
  }
  ],
  "name": "InitializeWithdrawalDelayerEvent",
  "type": "event"
  },
  {
  "anonymous": false,
  "inputs": [
  {
  "indexed": false,
  "internalType": "address",
  "name": "newEmergencyCouncil",
  "type": "address"
  }
  ],
  "name": "NewEmergencyCouncil",
  "type": "event"
  },
  {
  "anonymous": false,
  "inputs": [
  {
  "indexed": false,
  "internalType": "address",
  "name": "newHermezGovernanceAddress",
  "type": "address"
  }
  ],
  "name": "NewHermezGovernanceAddress",
  "type": "event"
  },
  {
  "anonymous": false,
  "inputs": [
  {
  "indexed": false,
  "internalType": "uint64",
  "name": "withdrawalDelay",
  "type": "uint64"
  }
  ],
  "name": "NewWithdrawalDelay",
  "type": "event"
  },
  {
  "anonymous": false,
  "inputs": [
  {
  "indexed": true,
  "internalType": "address",
  "name": "token",
  "type": "address"
  },
  {
  "indexed": true,
  "internalType": "address",
  "name": "owner",
  "type": "address"
  },
  {
  "indexed": false,
  "internalType": "uint192",
  "name": "amount",
  "type": "uint192"
  }
  ],
  "name": "Withdraw",
  "type": "event"
  },
  {
  "inputs": [],
  "name": "MAX_EMERGENCY_MODE_TIME",
  "outputs": [
  {
  "internalType": "uint64",
  "name": "",
  "type": "uint64"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "MAX_WITHDRAWAL_DELAY",
  "outputs": [
  {
  "internalType": "uint64",
  "name": "",
  "type": "uint64"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "uint64",
  "name": "_newWithdrawalDelay",
  "type": "uint64"
  }
  ],
  "name": "changeWithdrawalDelay",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "claimEmergencyCouncil",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "claimGovernance",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "address",
  "name": "_owner",
  "type": "address"
  },
  {
  "internalType": "address",
  "name": "_token",
  "type": "address"
  },
  {
  "internalType": "uint192",
  "name": "_amount",
  "type": "uint192"
  }
  ],
  "name": "deposit",
  "outputs": [],
  "stateMutability": "payable",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "address payable",
  "name": "_owner",
  "type": "address"
  },
  {
  "internalType": "address",
  "name": "_token",
  "type": "address"
  }
  ],
  "name": "depositInfo",
  "outputs": [
  {
  "internalType": "uint192",
  "name": "",
  "type": "uint192"
  },
  {
  "internalType": "uint64",
  "name": "",
  "type": "uint64"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "bytes32",
  "name": "",
  "type": "bytes32"
  }
  ],
  "name": "deposits",
  "outputs": [
  {
  "internalType": "uint192",
  "name": "amount",
  "type": "uint192"
  },
  {
  "internalType": "uint64",
  "name": "depositTimestamp",
  "type": "uint64"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "enableEmergencyMode",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "address",
  "name": "_to",
  "type": "address"
  },
  {
  "internalType": "address",
  "name": "_token",
  "type": "address"
  },
  {
  "internalType": "uint256",
  "name": "_amount",
  "type": "uint256"
  }
  ],
  "name": "escapeHatchWithdrawal",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "getEmergencyCouncil",
  "outputs": [
  {
  "internalType": "address",
  "name": "",
  "type": "address"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "getEmergencyModeStartingTime",
  "outputs": [
  {
  "internalType": "uint64",
  "name": "",
  "type": "uint64"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "getHermezGovernanceAddress",
  "outputs": [
  {
  "internalType": "address",
  "name": "",
  "type": "address"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "getWithdrawalDelay",
  "outputs": [
  {
  "internalType": "uint64",
  "name": "",
  "type": "uint64"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "hermezRollupAddress",
  "outputs": [
  {
  "internalType": "address",
  "name": "",
  "type": "address"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "isEmergencyMode",
  "outputs": [
  {
  "internalType": "bool",
  "name": "",
  "type": "bool"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "pendingEmergencyCouncil",
  "outputs": [
  {
  "internalType": "address payable",
  "name": "",
  "type": "address"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [],
  "name": "pendingGovernance",
  "outputs": [
  {
  "internalType": "address",
  "name": "",
  "type": "address"
  }
  ],
  "stateMutability": "view",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "address payable",
  "name": "newEmergencyCouncil",
  "type": "address"
  }
  ],
  "name": "transferEmergencyCouncil",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "address",
  "name": "newGovernance",
  "type": "address"
  }
  ],
  "name": "transferGovernance",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "address payable",
  "name": "_owner",
  "type": "address"
  },
  {
  "internalType": "address",
  "name": "_token",
  "type": "address"
  }
  ],
  "name": "withdrawal",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  },
  {
  "inputs": [
  {
  "internalType": "uint64",
  "name": "_initialWithdrawalDelay",
  "type": "uint64"
  },
  {
  "internalType": "address",
  "name": "_initialHermezRollup",
  "type": "address"
  },
  {
  "internalType": "address",
  "name": "_initialHermezGovernanceAddress",
  "type": "address"
  },
  {
  "internalType": "address payable",
  "name": "_initialEmergencyCouncil",
  "type": "address"
  }
  ],
  "name": "withdrawalDelayerInitializer",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
  }
  ]